import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, state } from 'lit/decorators.js';
import componentStyles from './se-featured-professionals.css.lit';
import '../se-heading/se-heading';
import '../se-link/se-link';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The SeContactsPlus component
 * @element se-contacts-plus
 */
@customElement('se-contacts-plus')
export class SeContactsPlus extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, false);

  @state() hasHeading: boolean;
  @state() hasLink: boolean;

  firstUpdated(): void {
    this.hasHeading = this.slots.test('heading');
    this.hasLink = this.slots.test('link');
  }

  render(): TemplateResult {
    return html` <div class="se-contacts-plus">
      ${this.hasHeading
        ? html` <span class="se-contacts-plus__title">
            <slot name="heading"></slot>
          </span>`
        : null}
      <div class="se-contacts-plus__teasers">
        <slot name="contact-teasers-plus"></slot>
      </div>
      ${this.hasLink
        ? html` <span class="se-contacts-plus__link">
            <slot name="link"></slot>
          </span>`
        : null}
    </div>`;
  }
}
